
import polygon from '../../assest/ahbaab/Clean Room Consumables banner.jpg'
import { Box } from "@mui/material"
import '../../styles/ahbaab/contactUsStyle.css'
import { ErrorMessage, Field, Form, Formik } from "formik"
import * as yup from 'yup'
import { MdEmail, MdOutlinePunchClock, MdLocalPhone } from "react-icons/md";
import { IoLocationSharp } from "react-icons/io5";

import { useState } from 'react'
import ThankYouDialoge from '../../components/ThankYouDialoge'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import Header from '../../common/ahbaab/Header/Header'
import Footer from '../../common/ahbaab/Footer/Footer'



const myMail = [
    {
        recipient: 'info@qu-lucency.com',
        subject: '',
        body: ''
    },
    {
        recipient: 'sales@qu-lucency.com',
        subject: '',
        body: ''
    }
];

const ContactUs = () => {

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };


    const [EnquiryData, SetEnquiryData] = useState({
        name: '',
        email: '',
        mobile: '',
        subject: '',
        message: '',
    })

    const [errorName, setErrorName] = useState("");
    const [errorEmail, setErrorEmail] = useState("");
    const [errorMobile, setErrorMobile] = useState("");
    const [bordrColor, setBordrColor] = useState("");

    const navigate = useNavigate()

    const onInputChnge = (e) => {
        const inpName = e.target.name;
        const inpVal = e.target.value;
        const cloned = { ...EnquiryData }
        cloned[inpName] = inpVal;
        SetEnquiryData(cloned);
    }


    const onSendClick = async (e) => {
        e.preventDefault();

        try {
            // Reset errors and color
            setErrorName("");
            setErrorEmail("");
            setErrorMobile("");
            setBordrColor("");

            // Perform input validation here before making the API call
            if (
                EnquiryData.name.length > 2 &&
                EnquiryData.email.includes("@") &&
                EnquiryData.mobile.length === 10 &&
                EnquiryData.subject.length > 2 &&
                EnquiryData.message.length > 2
            ) {
                setBordrColor('1px solid green');
                const sign_up = await axios.post(
                    'https://api-hosting-production-2021.up.railway.app/api/contact-us',
                    { ...EnquiryData }
                );
                SetEnquiryData(sign_up.data);
                console.log(sign_up.data);

                // Clear the form fields
                SetEnquiryData({
                    name: '',
                    email: '',
                    mobile: '',
                    subject: '',
                    message: '',
                });

                setOpen(true);
                // Provide user feedback or navigation here if needed
                // navigate('/contact')
                console.log('Form data submitted successfully!');
            } else {
                if (EnquiryData.name.length <= 2 || EnquiryData.name === '') setErrorName("enter name");
                if (!EnquiryData.email.includes("@") || EnquiryData.email === '') setErrorEmail("enter email");
                if (EnquiryData.mobile.length !== 10 || EnquiryData.mobile === '') setErrorMobile("enter valid 10 digit number");

                setBordrColor('1px solid white');
                // Provide user feedback for validation errors
                console.log('Form validation failed');
            }
        } catch (error) {
            // Provide user-friendly error message
            console.log('Error submitting form:', error.message);
        }
    };

    const dialNumber = () => {
        window.location.href = 'tel:+91 8448783350';
    };

    const emailClick = (recipient, subject, body) => {
        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = mailtoLink;
    };

    const defalutValue = {
        FullName: '',
        EmailID: '',
        Phone: '',
        YourMessage: '',

    }

    const validationSceema = yup.object().shape({
        // fieldLbale: yup.string().required('SS').min(10).max(10),
        FullName: yup.string().required('Name is Requird!'),
        EmailID: yup.string().required('Email is Requird!'),
        Phone: yup.string().required('Phone is Requird!'),
        YourMessage: yup.string().required('Your Message is Requird!'),

    })
    const handleSubmit = (value) => {
        console.log(value);

    }

    return (
        <>
            <Header />

            <Box className='Aboutus_topdiv'>
                <img src={polygon} alt="img" />
                <div className="hosp_aboutushead">
                    <h1>Contact Us</h1>
                </div>
            </Box>

            <div className="InTouchdiv">
                <div className="InTouchdiv_topdiv">
                    <h1 className=" fw-bold">Get In Touch With Us</h1>
                </div>

                <div className="row contentbetweenjustify">

                    <div className="col-lg-6 col-12 cardbody row newggg">
                        <Formik id="frmrecahrge" initialValues={defalutValue} validationSchema={validationSceema} onSubmit={handleSubmit} className="CustomForm fl-form ng-pristine ng-valid row">
                            {({ errors, touched, resetForm }) => {
                                return <Form className="row justify-content-center newformdiv">
                                    <div className="row justify-content-center p-0">
                                        <div className="col-lg-6 col-12 mt-2">

                                            <Field
                                                type='text'
                                                name='name'
                                                onChange={onInputChnge}
                                                value={EnquiryData.name}
                                                style={{ border: bordrColor, borderRadius: '4px' }}
                                                placeholder='Name'
                                                className={
                                                    `form-control
                                                    ${errors.name && touched.name ? ' is-invalid' : ''}`
                                                }
                                            />
                                            <p style={{ color: 'red', margin: 0, textAlign: 'start', paddingLeft: '5px', fontSize: '12px' }}>{errorName}</p>
                                        </div>

                                        <div className=" col-lg-6 col-12 mt-2">

                                            <Field
                                                type='text'
                                                name='email'
                                                onChange={onInputChnge}
                                                value={EnquiryData.email}
                                                style={{ border: bordrColor, borderRadius: '4px' }}
                                                placeholder='Email'
                                                className={
                                                    `form-control
                                                     ${errors.email && touched.email ? ' is-invalid' : ''}`
                                                }
                                            />
                                            <p style={{ color: 'red', margin: 0, textAlign: 'start', paddingLeft: '5px', fontSize: '12px' }}>{errorEmail}</p>
                                        </div>



                                        <div className="col-lg-6 col-12 mt-2">

                                            <Field
                                                type='text'
                                                name='mobile'
                                                onChange={onInputChnge}
                                                value={EnquiryData.mobile}
                                                style={{ border: bordrColor, borderRadius: '4px' }}
                                                placeholder='Phone'
                                                className={
                                                    `form-control
                                                    ${errors.mobile && touched.mobile ? ' is-invalid' : ''}`
                                                }
                                            />
                                            <p style={{ color: 'red', margin: 0, textAlign: 'start', paddingLeft: '5px', fontSize: '12px' }}> {errorMobile}</p>
                                        </div>


                                        <div className="col-lg-6 col-12 mt-2">

                                            <Field
                                                type='text'
                                                name='subject'
                                                onChange={onInputChnge}
                                                value={EnquiryData.subject}
                                                style={{ border: bordrColor, borderRadius: '4px' }}
                                                placeholder='Subject'
                                                className={
                                                    `form-control
                                                         ${errors.subject && touched.subject ? ' is-invalid' : ''}`
                                                }
                                            />
                                        </div>



                                        <div className=" mt-2">

                                            <Field
                                                as={'textarea'}
                                                rows={6}
                                                name='message'
                                                onChange={onInputChnge}
                                                value={EnquiryData.message}
                                                placeholder='Your Message'
                                                className={
                                                    `form-control
                                                     ${errors.message && touched.message ? ' is-invalid' : ''}`
                                                }
                                            />
                                        </div>


                                        <div className="col-12 mt-2">
                                            <button onClick={onSendClick} type="submit" className="btnbtnbtn">
                                                Send
                                            </button>

                                        </div>
                                    </div>

                                </Form>
                            }}
                        </Formik>
                    </div>

                    <div className=" col-lg-5 col-12 TouchInContact ">
                        <div className="Getcontactdiv">
                            <div className="ngo_icondiv">
                                <p> <IoLocationSharp className="icons" /></p>
                            </div>
                            <div className="ngocontact">
                                <p className='addres'>
                                    303, Kishan apt, Jamia Nagar, New Delhi, South Delhi- 110025, Delhi
                                </p>
                            </div>

                        </div>

                        <div className="Getcontactdiv">
                            <div className="ngo_icondiv">
                                <p> <MdLocalPhone className="icons" /></p>
                            </div>
                            <div className="ngocontact">
                                <p onClick={dialNumber}>+91 8448783350</p>
                                <span>Have a question? call us now</span>
                            </div>

                        </div>

                        <div className="Getcontactdiv">
                            <div className="ngo_icondiv">
                                <p> <MdEmail className="icons" /></p>
                            </div>
                            <div className="ngocontact">
                                {myMail.map((email, index) => (
                                    <p key={index}
                                        onClick={() => emailClick(email.recipient, email.subject, email.body)}
                                    >
                                        {email.recipient},
                                    </p>
                                ))}
                                <span>Need support? Drop us an email</span>
                            </div>

                        </div>

                        <div className="Getcontactdiv">
                            <div className="ngo_icondiv">
                                <p> <MdOutlinePunchClock className="icons" /></p>
                            </div>
                            <div className="ngocontact">
                                <p>Mon - Sat 09:30 - 18:00</p>
                                <span>We are open on</span>
                            </div>

                        </div>
                    </div>

                </div>
            </div>



            <ThankYouDialoge open={open} setOpen={setOpen} handleClose={handleClose} />

            <Footer />


        </>
    )
}

export default ContactUs